import {BaseElement} from "../../../../interfaces/BaseElement";
import {EventBus} from "../../../../interfaces/EventBus";
import {hasFavorites} from "../../../../../functions";

export class FavoriteButton {
    #rootElement;

    constructor() {
        this.#rootElement = new BaseElement()
            .event('click', this.#clickHandler)
            .addClass('mobile-search__favorite-button', 'icon-favorite_selected', 'transparent');

        EventBus.add('favoriteButtonUpdate', this.#update.bind(this));
    }

    get rootElement() {
        return this.#rootElement;
    }

    remove() {
        EventBus.remove('favoriteButtonUpdate');

        this.#rootElement.remove();
        this.#rootElement = null;
    }

    #update() {
        if (hasFavorites()) {
            this.#rootElement.removeClass('transparent');
        } else {
            this.#rootElement.addClass('transparent');
        }
    }

    #clickHandler() {
        if (!hasFavorites())
            return;

        console.log('favorite click handler');
    }
}